import {OnClickReload, ReloadButton} from "components/src/common/ReloadButton";
import {PageTitle, type PageTitleProps} from "components/src/layout/PageTitle";
import Row from "react-bootstrap/Row";

interface PageHeaderProps {
    icon: PageTitleProps["icon"];
    title: string;
    onClickReload?: OnClickReload;
}

export const PageHeader = ({icon, title, onClickReload}: PageHeaderProps) => {
    return (
        <Row className="px-4">
            <div className="d-flex flex-row align-items-center border-bottom mb-4">
                <div className="d-flex justify-content-start">
                    <PageTitle title={title} icon={icon}/>
                </div>
                <div className="d-flex flex-fill justify-content-end">
                    <ReloadButton onClickReload={onClickReload}/>
                </div>
            </div>
        </Row>
    );
};
